import { createContext, useContext } from 'react';
import type { GuidePageId } from './guideContent';

// Lets deep panel components (tooltip "Learn more" controls) open the Graph
// guide on a specific page without threading a callback through every prop
// list. The page owns the open/last-page state and provides the real opener.
export type GraphGuideApi = {
  // no page = reopen on the page the guide was last closed on
  openGuide: (page?: GuidePageId, section?: string) => void;
};

export const GraphGuideContext = createContext<GraphGuideApi>({
  openGuide: () => {},
});

export const useGraphGuide = () => useContext(GraphGuideContext);
